module.exports = __webpack_public_path__ + "img/Weapon_237.5c5cd975.png";